import { Directive, inject } from '@angular/core'
import { DIALOG_DATA, DialogRef } from '@angular/cdk/dialog'
import { Router } from '@angular/router'

import { Notification } from '../models/notification.model'

/**
 * Base de los modales de notificación: la notificación que los abrió, cerrar y
 * seguir el link. El panel ya la marcó como leída antes de abrirlos.
 */
@Directive()
export class NotificationModalBase {
  readonly #router = inject(Router)

  protected readonly notification = inject<Notification>(DIALOG_DATA)
  protected readonly dialogRef = inject(DialogRef)

  protected close(): void {
    this.dialogRef.close()
  }

  /** Cierra y lleva al link del aviso: ruta interna o pestaña nueva. */
  protected go(): void {
    const link = this.notification.link
    if (!link) return

    this.dialogRef.close()

    if (link.startsWith('/')) void this.#router.navigateByUrl(link)
    else window.open(link, '_blank', 'noopener')
  }
}
